import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import type { HTMLProps } from 'react';
interface Props extends HTMLProps<HTMLDivElement> {
  contentClassName?: string;
}
function PageTabsContainer(t0) {
  const $ = _c(16);
  let children;
  let className;
  let contentClassName;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      contentClassName,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = contentClassName;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    contentClassName = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("flex w-full flex-col items-center justify-center border-b", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== contentClassName) {
    t2 = cn("w-[1280px]", contentClassName);
    $[7] = contentClassName;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[9] = children;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t3) {
    t4 = <div className={t1} {...props}>{t3}</div>;
    $[12] = props;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
export default PageTabsContainer;